import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { QuestionBankModel } from 'app/company-audit/models/question-bank.model';
import { DocumentModel } from 'app/company-audit/models/document.model';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { CompanyAuditModuleViewModel } from 'app/company-audit/models/company-audit-module-view.model';
import { AccountService } from '../../../core/services/account.service';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';

@Component({
  selector: 'app-lender-audit-module-view',
  templateUrl: './lender-audit-module-view.component.html',
    styleUrls: ['./lender-audit-module-view.component.css']
})
export class LenderAuditModuleViewComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    createAuditFrom: FormGroup;
    auditModule: CompanyAuditModuleViewModel;
    submitAttempt: boolean = false;
    auditId: string;
    moduleId: string;
    questionsModel: QuestionBankModel[];
    auditDocuments: DocumentModel[];
    companyUser: CompanyUserModel;
    companyAuditModel: ICompanyAuditDetailsModel;
    pageNumber: number = 0;
    progress: number = 0;
    score: number = 0;
    potentialScore: number = 0;
    totalPercentage: number = 0;

    constructor(
        private companyAuditService: CompanyAuditService,
        private accountService: AccountService,
        private location: Location,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {

        this.auditId = this.activatedRoute.snapshot.params['auditId'];
        this.moduleId = this.activatedRoute.snapshot.params['moduleId'];

        this.companyAuditService.get(this.auditId).subscribe(auditInfo => {
            this.companyAuditModel = auditInfo;
            this.companyAuditService.getAuditModule(this.auditId, this.moduleId).subscribe(auditModule => {
                this.auditModule = auditModule;
                this.headerTitle = {
                    title: auditModule.moduleDescription,
                    breadcrumbs: [
                        { title: auditInfo.companyName, url: ['/lenders/company/' + auditInfo.companyId] }
                    ]
                };
            });
        });

        this.companyAuditService.getAnswers(this.auditId, this.moduleId).subscribe(
            questions => {
                this.questionsModel = questions;
                this.calculateProgress();
                this.score = this.questionsModel.reduce((sum, current) => sum + current.score, 0);
                this.potentialScore = this.questionsModel.reduce((sum, current) => sum + current.questions.length, 0) * 2;
                this.totalPercentage = Math.round(this.score / this.potentialScore * 100);
            },
            error => this.errors = error.errorList
        );

        // ---------- Load uploaded documents for this module ---------- //
        this.companyAuditService.getDocuments(this.moduleId).subscribe(
            documents => {
                this.auditDocuments = documents;
            },
            error => this.errors = error.errorList
        );
    }

    calculateProgress() {
        this.progress = Math.round(100 / this.questionsModel.length * (this.pageNumber + 1));
    }

    pageUp() {
        this.pageNumber = this.pageNumber + 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    pageDown() {
        this.pageNumber = this.pageNumber - 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    onBack(): void {
        this.location.back();
    }

}
